export const SETTINGS_DATA_SECURITY_COPY = {
	ADD_EMAIL: 'Add Email',
	ADD_NEW_MONITOR: 'Add New Monitor',
	DELETE_MONITOR_CONFIRMATION: 'Are you sure you want to delete this monitor?',
	EDIT_MONITOR_SETTINGS: (name: string) => `Edit ${name} Monitor Settings`,
	EMAIL_TO: 'Email To',
	MONITORS: 'Monitors',
	MONITOR_DELETED: 'Monitor deleted',
	MONITOR_SAVED: 'Monitor saved',
	MONITOR_SETTINGS: (name: string) => `Monitor Settings - ${name}`,
	MONITOR_TYPE: 'Monitor Type',
	MONITOR_WINDOW: 'What is the monitoring window for this application?',
	NEW_USER: 'New User',
	NOTIFICATION_SETTINGS: 'Notification Settings',
	NO_NOTIFICATIONS: 'No Notifications',
	OBJECT_AND_FIELD_ACCESS: 'Object & Field Access',
	ONLY_CREATE_NEW_MONITORS: 'Only Create New Monitors',
	OVERWRITE_MONITORS: 'Overwrite Monitors',
	OVERWRITE_MONITORS_WARNING: (count: number) => `This will overwrite monitors on ${count} applications`,
	OVERWRITE_MONITOR_WARNING: 'This will overwrite a monitor on 1 application',
	PERSONAL: '*Personal',
	SAVE_COUNT_MONITORS: (count : number) => `Save ${count} Monitors`,
	SAVE_MONITOR: 'Save Monitor',
	SAVE_ONE_MONITOR: 'Save 1 Monitor',
	SELECT_MONITOR_TYPE: 'Select A Monitor Type',
	SETUP_AUDIT_TRAIL: 'Setup Audit Trail',
	UPTIME: 'Uptime',
	// eslint-disable-next-line max-len
	UPTIME_TOOLTIP: 'These monitoring windows are predefined periods, not rolling windows. For example the hourly window will look for API calls between :00-:59, not a rolling 60 minutes. The same goes for Daily, Weekly, and Monthly.',
	UPTIME_WEEKDAYS_TRIGGER: 'Only Trigger on Weekdays'
};
